module.exports = __webpack_public_path__ + "img/nas.6a698b83.svg";